export const FOCUS_STATE_BASE_CLASSES = "outline-none ring-primary-lighten-50"
export const FORM_COMPONENT_FOCUS_CLASSES =
  "focus-within:ring-4 focus-visible:ring-4 peer-focus-visible:ring-4"
